import request from 'config/axios'

export const accountType = payload => request.get('resources/v2/banks/account-types', payload)
export const ownerTypes = payload => request.get('resources/v2/banks/owner-types', payload)
export const banks = (showFavorites = false) =>
  request.get(`resources/v2/banks?favorite=${showFavorites}`)

export const updateBankInfo = ({ eletronicSignature, ...payload }) => {
  const data = { ...payload, electronicSignature: eletronicSignature }
  return request.put(`registrar/v1/customers/bankaccounts/${data.id}`, data)
}

export const updateBankInfoToken = ({ otpCode, ...payload }) => {
  const data = { ...payload, otpCode }
  return request.put(`registrar/v2/customers/bankaccounts/${data.id}`, data)
}

export const removeBankInfo = payload => {
  const { eletronicSignature, id } = payload
  const data = new FormData()

  data.append('electronicSignature', eletronicSignature)
  return request.delete(`registrar/v1/customers/bankaccounts/${id}`, { data })
}

export const removeBankInfoToken = payload => {
  const { otpCode, id } = payload
  const data = { otpCode }
  return request.delete(`registrar/v2/customers/bankaccounts/${id}`, { data })
}

export const createBankInfo = ({ eletronicSignature, ...payload }) => {
  const data = { ...payload, electronicSignature: eletronicSignature }
  return request.post('registrar/v1/customers/bankaccounts', data)
}

export const createBankInfoToken = ({ otpCode, ...payload }) => {
  const data = { ...payload, otpCode }
  return request.post('registrar/v2/customers/bankaccounts', data)
}
